import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import classNames from 'classnames';
import * as React from 'react';

import styles from './MoreParametersPikBanner.css';

export interface IMoreParametersPickBannerProps {
  context: IAdFoxBannerContext;
}

export function MoreParametersPikBanner(props: IMoreParametersPickBannerProps) {
  return (
    <a
      href={props.context.reference}
      target="_blank"
      className={classNames(styles['link'], styles['link_redesign'])}
      rel="noreferrer"
    >
      <img src={props.context.imageURL} />
    </a>
  );
}
